import React from 'react'

import { calculateTotalBudget, convertCurrency } from '@albacross/frontend-utils'

import CampaignProgressBase from '../../components/campaigns/CampaignProgress'

// Loose prop typing until CampaignProgress itself is converted to TS.
const CampaignProgress = CampaignProgressBase as React.ComponentType<any>

const progressHelper = (first, second, percent, color = false, ctr = false) => (
  <CampaignProgress color={color} height={2} value={percent || 0} width="100%">
    {`${first} – ${second} – ${Number.isInteger(percent) && !ctr ? percent : percent.toFixed(2)}%`}
  </CampaignProgress>
)

export const renderBudget = field => data =>
  `${data[field]} ${data.currency} (${convertCurrency(data[field], data.currency, 'SEK')} SEK)`

export const renderTotalBudget =
  () =>
  ({ currency, dailyBudget, startDate, endDate }) => {
    const totalBudget = calculateTotalBudget(dailyBudget, [startDate, endDate]).toFixed(2)
    return `${totalBudget} ${currency} (${convertCurrency(totalBudget as any, currency, 'SEK')} SEK)`
  }

export const renderDate = ({ startDate, endDate, percent }) => progressHelper(startDate, endDate, percent)

export const renderProgress =
  (field, color = false) =>
  (firstKey, secondKey, percentKey = 'percent', ctr = false) =>
  data => {
    const firstValue = data[field][firstKey]
    const secondValue = data[field][secondKey]
    const percent = data[field][percentKey]

    return progressHelper(firstValue, secondValue, percent, color, ctr)
  }

export const renderSpent = data => `${data.spent.cost} ${data.spent.currency}`

export const renderRegion = data => `${data.region}`
